import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from '@infrastructure/shared/icons/icon-subset';
import { Title } from '@angular/platform-browser';

import Swal from 'sweetalert2';

import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';

import { perfil, perfilUsarAccesoDe } from '@domain/models/_profile';
import { UserAccessService } from '@infrastructure/services/catalog/user-access.service';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '@application/services/account.service';
import { environment } from 'environments/environment';

interface VigenciaResponse {
  codigo?: string;
  mensaje?: string;
}
interface UserStatusResponse {
  bloqueado?: boolean;
  mensaje?: string;
}

@Component({
  selector: 'body',
  template: `
    <app-loader></app-loader>
    <router-outlet></router-outlet>
  `,
  providers: [UserAccessService],
})
export class AppComponent implements OnInit {
  title = 'Alpura LQL';
  isLogin = false;
  perfilUsuario: KeycloakProfile | null = null;
  public perfil = perfil;
  public perfilUsarAccesoDe = perfilUsarAccesoDe;

  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService,
    private _serv: UserAccessService,
    private readonly keycloak: KeycloakService,
    public _http: HttpClient,
    private accountService: AccountService
  ) {
    titleService.setTitle(this.title);
    iconSetService.icons = { ...iconSubset };
  }
  /**
   *
   */
  public async ngOnInit() {
  }

  private async loadUserData() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
    this.isLogin = true;
    if (this.isLogin) {
      this.perfilUsuario = {id:"176fe699-bcfe-4ba5-b7a9-21fcdac87c3a"};
      this.getPerfilUsuario(this.perfilUsuario.id);
      const idUsuario = this.perfilUsuario.id;
      this.validaVigenciaUsuario(idUsuario!);
    }
  }

  validaVigenciaUsuario(userId: string) {
    this._serv.validarVigenciaUsuarioPoIdUsuario(userId).subscribe((s: any) => {
      if (s.error.codigo === '1012') {
        localStorage.clear();
        this.keycloak.logout();
      }
    });
  }

  validaVigencia(userId: string) {
    const urlVigencia = `${environment.validaVigencia}${userId}`;
    const body = { id: userId };
    this._http
      .post<VigenciaResponse>(urlVigencia, body)

      .subscribe(
        (response) => {
          if (response.codigo) {
            Swal.fire('Error', response.mensaje, 'error').then(() => {
              this.keycloak.logout();
              localStorage.clear();
              this.loadUserData();
            });
          } else {

          }
        },
        (error) => {
          this.keycloak.logout();
          localStorage.clear();
          this.loadUserData();
          Swal.fire(
            'Error',
            'Error al validar la vigencia del usuario',
            'error'
          ).then(() => {});
        }
      );
  }

  getPerfilUsuario(id: any) {
    localStorage.setItem('idUsuario', JSON.stringify(id));

    this._serv.findProfileByUser(id).subscribe(
      (response) => {
        if (response) {
          response.forEach((item: any) => {
            // -------- Para USUARIO -----------
            if (perfil.usuario.id_user === '') {
              perfil.usuario.id_user = item.id;
            }
            if (perfil.usuario.nombre === '') {
              perfil.usuario.nombre = item.nombre;
            }
            if (perfil.usuario.ap_paterno === '') {
              perfil.usuario.ap_paterno = item.ap_paterno;
            }
            if (perfil.usuario.ap_materno === '') {
              perfil.usuario.ap_materno = item.ap_materno;
            }
            if (perfil.usuario.email === '') {
              perfil.usuario.email = item.email;
            }
            if (perfil.usuario.idUserRefer === '') {
              perfil.usuario.idUserRefer = item.idUserRefer;
            }

            // -------- Para PERMISOS -----------

            if (item.producto === 'MaestroSocios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MaestroSocios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MaestroSocios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MaestroSocios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MaestroSocios.borrar = true;
              }
            }
            if (item.producto === 'MantPrecioCompo') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantPrecioCompo.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantPrecioCompo.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantPrecioCompo.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantPrecioCompo.borrar = true;
              }
            }
            if (item.producto === 'PrecioPromSem') {
              if (item.funcion === 'Editar') {
                perfil.permisos.PrecioPromSem.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.PrecioPromSem.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.PrecioPromSem.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.PrecioPromSem.borrar = true;
              }
            }
            if (item.producto === 'PrecioFijoSem') {
              if (item.funcion === 'Editar') {
                perfil.permisos.PrecioFijoSem.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.PrecioFijoSem.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.PrecioFijoSem.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.PrecioFijoSem.borrar = true;
              }
            }
            if (item.producto === 'PrecioFijoVig') {
              if (item.funcion === 'Editar') {
                perfil.permisos.PrecioFijoVig.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.PrecioFijoVig.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.PrecioFijoVig.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.PrecioFijoVig.borrar = true;
              }
            }
            if (item.producto === 'MantAcciones') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantAcciones.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantAcciones.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantAcciones.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantAcciones.borrar = true;
              }
            }
            if (item.producto === 'MantContratos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantContratos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantContratos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantContratos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantContratos.borrar = true;
              }
            }
            if (item.producto === 'MantLitrosAcciones') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantLitrosAcciones.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantLitrosAcciones.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantLitrosAcciones.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantLitrosAcciones.borrar = true;
              }
            }
            if (item.producto === 'TopesDia') {
              if (item.funcion === 'Editar') {
                perfil.permisos.TopesDia.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.TopesDia.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.TopesDia.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.TopesDia.borrar = true;
              }
            }
            if (item.producto === 'TopesSemana') {
              if (item.funcion === 'Editar') {
                perfil.permisos.TopesSemana.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.TopesSemana.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.TopesSemana.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.TopesSemana.borrar = true;
              }
            }
            if (item.producto === 'FormulasCalidad') {
              if (item.funcion === 'Editar') {
                perfil.permisos.FormulasCalidad.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.FormulasCalidad.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.FormulasCalidad.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.FormulasCalidad.borrar = true;
              }
            }
            if (item.producto === 'Bancos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Bancos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Bancos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Bancos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Bancos.borrar = true;
              }
            }
            if (item.producto === 'Rutas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Rutas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Rutas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Rutas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Rutas.borrar = true;
              }
            }
            if (item.producto === 'Sucursales') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Sucursales.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Sucursales.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Sucursales.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Sucursales.borrar = true;
              }
            }
            if (item.producto === 'Tanques') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Tanques.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Tanques.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Tanques.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Tanques.borrar = true;
              }
            }
            if (item.producto === 'Veterinarios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Veterinarios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Veterinarios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Veterinarios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Veterinarios.borrar = true;
              }
            }
            if (item.producto === 'Plantas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Plantas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Plantas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Plantas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Plantas.borrar = true;
              }
            }
            if (item.producto === 'TipoDesvios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.TipoDesvios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.TipoDesvios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.TipoDesvios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.TipoDesvios.borrar = true;
              }
            }
            if (item.producto === 'RelPago') {
              if (item.funcion === 'Editar') {
                perfil.permisos.RelPago.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.RelPago.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.RelPago.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.RelPago.borrar = true;
              }
            }
            if (item.producto === 'Conceptos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Conceptos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Conceptos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Conceptos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Conceptos.borrar = true;
              }
            }
            if (item.producto === 'ControlConcepCia') {
              if (item.funcion === 'Editar') {
                perfil.permisos.ControlConcepCia.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.ControlConcepCia.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.ControlConcepCia.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.ControlConcepCia.borrar = true;
              }
            }
            if (item.producto === 'CompTransportistas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.CompTransportistas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.CompTransportistas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.CompTransportistas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.CompTransportistas.borrar = true;
              }
            }
            if (item.producto === 'MovRecoleccion') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MovRecoleccion.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MovRecoleccion.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MovRecoleccion.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MovRecoleccion.borrar = true;
              }
            }
            if (item.producto === 'AgrupRutasMovRecol') {
              if (item.funcion === 'Editar') {
                perfil.permisos.AgrupRutasMovRecol.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.AgrupRutasMovRecol.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.AgrupRutasMovRecol.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.AgrupRutasMovRecol.borrar = true;
              }
            }
            if (item.producto === 'ConcFactSocios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.ConcFactSocios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.ConcFactSocios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.ConcFactSocios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.ConcFactSocios.borrar = true;
              }
            }
            if (item.producto === 'GrupAparcerias') {
              if (item.funcion === 'Editar') {
                perfil.permisos.GrupAparcerias.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.GrupAparcerias.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.GrupAparcerias.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.GrupAparcerias.borrar = true;
              }
            }
            if (item.producto === 'RegionesRecol') {
              if (item.funcion === 'Editar') {
                perfil.permisos.RegionesRecol.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.RegionesRecol.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.RegionesRecol.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.RegionesRecol.borrar = true;
              }
            }
            if (item.producto === 'GrupArrendamientos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.GrupArrendamientos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.GrupArrendamientos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.GrupArrendamientos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.GrupArrendamientos.borrar = true;
              }
            }
            if (item.producto === 'ContSirla') {
              if (item.funcion === 'Editar') {
                perfil.permisos.ContSirla.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.ContSirla.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.ContSirla.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.ContSirla.borrar = true;
              }
            }
            if (item.producto === 'TablaCompensaciónLog') {
              if (item.funcion === 'Editar') {
                perfil.permisos.TablaCompensacionLog.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.TablaCompensacionLog.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.TablaCompensacionLog.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.TablaCompensacionLog.borrar = true;
              }
            }
            if (item.producto === 'MantClaseA') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantClaseA.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantClaseA.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantClaseA.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantClaseA.borrar = true;
              }
            }
            if (item.producto === 'Capturas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Capturas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Capturas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Capturas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Capturas.borrar = true;
              }
            }
            if (item.producto === 'Reportes') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Reportes.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Reportes.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Reportes.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Reportes.borrar = true;
              }
            }
            if (item.producto === 'AnLecheTanque') {
              if (item.funcion === 'Editar') {
                perfil.permisos.AnLecheTanque.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.AnLecheTanque.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.AnLecheTanque.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.AnLecheTanque.borrar = true;
              }
            }
            if (item.producto === 'Procesos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Procesos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Procesos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Procesos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Procesos.borrar = true;
              }
            }
            if (item.producto === 'CargaMilkoScan') {
              if (item.funcion === 'Editar') {
                perfil.permisos.CargaMilkoScan.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.CargaMilkoScan.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.CargaMilkoScan.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.CargaMilkoScan.borrar = true;
              }
            }
            if (item.producto === 'CargaColLPC') {
              if (item.funcion === 'Editar') {
                perfil.permisos.CargaColLPC.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.CargaColLPC.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.CargaColLPC.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.CargaColLPC.borrar = true;
              }
            }
            if (item.producto === 'Consultas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Consultas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Consultas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Consultas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Consultas.borrar = true;
              }
            }
            if (item.producto === 'DirSocios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.DirSocios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.DirSocios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.DirSocios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.DirSocios.borrar = true;
              }
            }
            if (item.producto === 'Deducciones') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Deducciones.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Deducciones.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Deducciones.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Deducciones.borrar = true;
              }
            }
            if (item.producto === 'Contabilidad') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Contabilidad.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Contabilidad.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Contabilidad.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Contabilidad.borrar = true;
              }
            }
            if (item.producto === 'ProcCrioscopia') {
              if (item.funcion === 'Editar') {
                perfil.permisos.ProcCrioscopia.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.ProcCrioscopia.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.ProcCrioscopia.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.ProcCrioscopia.borrar = true;
              }
            }
            if (item.producto === 'Accesos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Accesos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Accesos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Accesos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Accesos.borrar = true;
              }
            }
            if (item.producto === 'Usuarios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Usuarios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Usuarios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Usuarios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Usuarios.borrar = true;
              }
            }
            if (item.producto === 'Perfiles') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Perfiles.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Perfiles.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Perfiles.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Perfiles.borrar = true;
              }
            }
            if (item.producto === 'JuegoVal') {
              if (item.funcion === 'Editar') {
                perfil.permisos.JuegoVal.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.JuegoVal.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.JuegoVal.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.JuegoVal.borrar = true;
              }
            }
            if (item.producto === 'Regiones') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Regiones.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Regiones.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Regiones.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Regiones.borrar = true;
              }
            }

            // -------- Para PERMISOS -----------
          });
          localStorage.setItem('usuario', JSON.stringify(perfil.usuario));

          if (perfil.usuario.idUserRefer === '0') {
            localStorage.setItem('permisos', JSON.stringify(perfil.permisos));
          }
          if (perfil.usuario.idUserRefer != '0') {
            this._serv
              .obenerUsuarioPoIdUsuario(perfil.usuario.idUserRefer)
              .subscribe((s: any) => {
                this._serv
                  .findProfileByUser(s.idUserKeycloak)
                  .subscribe((response) => {
                    if (response) {
                      this.mapearPermisos(response);
                    } else {
                      Swal.fire({
                        icon: 'error',
                        title: 'Sin información para usuario ' + id,
                        html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; No se pudo recuperar el perfil del usuario`,
                      });
                    }
                  });
              });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Sin información para usuario ' + id,
            html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; No se pudo recuperar el perfil del usuario`,
          });
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Ocurrió un error',
          html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; No se pudo recuperar el perfil del usuario`,
        });
      }
    );
  }

  getPerfilUsuarioOld(id: any) {
    localStorage.setItem('idUsuario', JSON.stringify(id));

    this._serv.findProfileByUser(id).subscribe(
      (response) => {
        if (response) {
          response.forEach((item: any) => {
            // -------- Para USUARIO -----------
            if (perfil.usuario.id_user === '') {
              perfil.usuario.id_user = item.id;
            }
            if (perfil.usuario.nombre === '') {
              perfil.usuario.nombre = item.nombre;
            }
            if (perfil.usuario.ap_paterno === '') {
              perfil.usuario.ap_paterno = item.ap_paterno;
            }
            if (perfil.usuario.ap_materno === '') {
              perfil.usuario.ap_materno = item.ap_materno;
            }
            if (perfil.usuario.email === '') {
              perfil.usuario.email = item.email;
            }
            if (perfil.usuario.idUserRefer === '') {
              perfil.usuario.idUserRefer = item.idUserRefer;
            }

            // -------- Para PERMISOS -----------

            if (item.producto === 'MaestroSocios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MaestroSocios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MaestroSocios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MaestroSocios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MaestroSocios.borrar = true;
              }
            }
            if (item.producto === 'MantPrecioCompo') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantPrecioCompo.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantPrecioCompo.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantPrecioCompo.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantPrecioCompo.borrar = true;
              }
            }
            if (item.producto === 'PrecioPromSem') {
              if (item.funcion === 'Editar') {
                perfil.permisos.PrecioPromSem.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.PrecioPromSem.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.PrecioPromSem.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.PrecioPromSem.borrar = true;
              }
            }
            if (item.producto === 'PrecioFijoSem') {
              if (item.funcion === 'Editar') {
                perfil.permisos.PrecioFijoSem.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.PrecioFijoSem.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.PrecioFijoSem.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.PrecioFijoSem.borrar = true;
              }
            }
            if (item.producto === 'PrecioFijoVig') {
              if (item.funcion === 'Editar') {
                perfil.permisos.PrecioFijoVig.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.PrecioFijoVig.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.PrecioFijoVig.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.PrecioFijoVig.borrar = true;
              }
            }
            if (item.producto === 'MantAcciones') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantAcciones.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantAcciones.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantAcciones.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantAcciones.borrar = true;
              }
            }
            if (item.producto === 'MantContratos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantContratos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantContratos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantContratos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantContratos.borrar = true;
              }
            }
            if (item.producto === 'MantLitrosAcciones') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantLitrosAcciones.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantLitrosAcciones.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantLitrosAcciones.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantLitrosAcciones.borrar = true;
              }
            }
            if (item.producto === 'TopesDia') {
              if (item.funcion === 'Editar') {
                perfil.permisos.TopesDia.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.TopesDia.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.TopesDia.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.TopesDia.borrar = true;
              }
            }
            if (item.producto === 'TopesSemana') {
              if (item.funcion === 'Editar') {
                perfil.permisos.TopesSemana.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.TopesSemana.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.TopesSemana.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.TopesSemana.borrar = true;
              }
            }
            if (item.producto === 'FormulasCalidad') {
              if (item.funcion === 'Editar') {
                perfil.permisos.FormulasCalidad.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.FormulasCalidad.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.FormulasCalidad.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.FormulasCalidad.borrar = true;
              }
            }
            if (item.producto === 'Bancos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Bancos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Bancos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Bancos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Bancos.borrar = true;
              }
            }
            if (item.producto === 'Rutas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Rutas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Rutas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Rutas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Rutas.borrar = true;
              }
            }
            if (item.producto === 'Sucursales') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Sucursales.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Sucursales.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Sucursales.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Sucursales.borrar = true;
              }
            }
            if (item.producto === 'Tanques') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Tanques.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Tanques.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Tanques.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Tanques.borrar = true;
              }
            }
            if (item.producto === 'Veterinarios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Veterinarios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Veterinarios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Veterinarios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Veterinarios.borrar = true;
              }
            }
            if (item.producto === 'Plantas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Plantas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Plantas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Plantas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Plantas.borrar = true;
              }
            }
            if (item.producto === 'TipoDesvios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.TipoDesvios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.TipoDesvios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.TipoDesvios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.TipoDesvios.borrar = true;
              }
            }
            if (item.producto === 'RelPago') {
              if (item.funcion === 'Editar') {
                perfil.permisos.RelPago.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.RelPago.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.RelPago.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.RelPago.borrar = true;
              }
            }
            if (item.producto === 'Conceptos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Conceptos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Conceptos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Conceptos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Conceptos.borrar = true;
              }
            }
            if (item.producto === 'ControlConcepCia') {
              if (item.funcion === 'Editar') {
                perfil.permisos.ControlConcepCia.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.ControlConcepCia.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.ControlConcepCia.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.ControlConcepCia.borrar = true;
              }
            }
            if (item.producto === 'CompTransportistas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.CompTransportistas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.CompTransportistas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.CompTransportistas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.CompTransportistas.borrar = true;
              }
            }
            if (item.producto === 'MovRecoleccion') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MovRecoleccion.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MovRecoleccion.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MovRecoleccion.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MovRecoleccion.borrar = true;
              }
            }
            if (item.producto === 'AgrupRutasMovRecol') {
              if (item.funcion === 'Editar') {
                perfil.permisos.AgrupRutasMovRecol.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.AgrupRutasMovRecol.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.AgrupRutasMovRecol.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.AgrupRutasMovRecol.borrar = true;
              }
            }
            if (item.producto === 'ConcFactSocios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.ConcFactSocios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.ConcFactSocios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.ConcFactSocios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.ConcFactSocios.borrar = true;
              }
            }
            if (item.producto === 'GrupAparcerias') {
              if (item.funcion === 'Editar') {
                perfil.permisos.GrupAparcerias.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.GrupAparcerias.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.GrupAparcerias.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.GrupAparcerias.borrar = true;
              }
            }
            if (item.producto === 'RegionesRecol') {
              if (item.funcion === 'Editar') {
                perfil.permisos.RegionesRecol.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.RegionesRecol.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.RegionesRecol.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.RegionesRecol.borrar = true;
              }
            }
            if (item.producto === 'GrupArrendamientos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.GrupArrendamientos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.GrupArrendamientos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.GrupArrendamientos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.GrupArrendamientos.borrar = true;
              }
            }
            if (item.producto === 'ContSirla') {
              if (item.funcion === 'Editar') {
                perfil.permisos.ContSirla.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.ContSirla.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.ContSirla.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.ContSirla.borrar = true;
              }
            }
            if (item.producto === 'TablaCompensaciónLog') {
              if (item.funcion === 'Editar') {
                perfil.permisos.TablaCompensacionLog.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.TablaCompensacionLog.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.TablaCompensacionLog.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.TablaCompensacionLog.borrar = true;
              }
            }
            if (item.producto === 'MantClaseA') {
              if (item.funcion === 'Editar') {
                perfil.permisos.MantClaseA.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.MantClaseA.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.MantClaseA.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.MantClaseA.borrar = true;
              }
            }
            if (item.producto === 'Capturas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Capturas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Capturas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Capturas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Capturas.borrar = true;
              }
            }
            if (item.producto === 'Reportes') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Reportes.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Reportes.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Reportes.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Reportes.borrar = true;
              }
            }
            if (item.producto === 'AnLecheTanque') {
              if (item.funcion === 'Editar') {
                perfil.permisos.AnLecheTanque.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.AnLecheTanque.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.AnLecheTanque.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.AnLecheTanque.borrar = true;
              }
            }
            if (item.producto === 'Procesos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Procesos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Procesos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Procesos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Procesos.borrar = true;
              }
            }
            if (item.producto === 'CargaMilkoScan') {
              if (item.funcion === 'Editar') {
                perfil.permisos.CargaMilkoScan.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.CargaMilkoScan.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.CargaMilkoScan.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.CargaMilkoScan.borrar = true;
              }
            }
            if (item.producto === 'CargaColLPC') {
              if (item.funcion === 'Editar') {
                perfil.permisos.CargaColLPC.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.CargaColLPC.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.CargaColLPC.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.CargaColLPC.borrar = true;
              }
            }
            if (item.producto === 'Consultas') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Consultas.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Consultas.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Consultas.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Consultas.borrar = true;
              }
            }
            if (item.producto === 'DirSocios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.DirSocios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.DirSocios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.DirSocios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.DirSocios.borrar = true;
              }
            }
            if (item.producto === 'Deducciones') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Deducciones.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Deducciones.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Deducciones.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Deducciones.borrar = true;
              }
            }
            if (item.producto === 'Contabilidad') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Contabilidad.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Contabilidad.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Contabilidad.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Contabilidad.borrar = true;
              }
            }
            if (item.producto === 'ProcCrioscopia') {
              if (item.funcion === 'Editar') {
                perfil.permisos.ProcCrioscopia.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.ProcCrioscopia.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.ProcCrioscopia.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.ProcCrioscopia.borrar = true;
              }
            }
            if (item.producto === 'Accesos') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Accesos.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Accesos.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Accesos.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Accesos.borrar = true;
              }
            }
            if (item.producto === 'Usuarios') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Usuarios.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Usuarios.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Usuarios.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Usuarios.borrar = true;
              }
            }
            if (item.producto === 'Perfiles') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Perfiles.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Perfiles.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Perfiles.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Perfiles.borrar = true;
              }
            }
            if (item.producto === 'JuegoVal') {
              if (item.funcion === 'Editar') {
                perfil.permisos.JuegoVal.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.JuegoVal.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.JuegoVal.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.JuegoVal.borrar = true;
              }
            }
            if (item.producto === 'Regiones') {
              if (item.funcion === 'Editar') {
                perfil.permisos.Regiones.edicion = true;
              }
              if (item.funcion === 'Consulta') {
                perfil.permisos.Regiones.consulta = true;
              }
              if (item.funcion === 'Reportes') {
                perfil.permisos.Regiones.reportes = true;
              }
              if (item.funcion === 'Borrar') {
                perfil.permisos.Regiones.borrar = true;
              }
            }

            // -------- Para PERMISOS -----------
          });

          localStorage.setItem('usuario', JSON.stringify(perfil.usuario));

          if (perfil.usuario.idUserRefer === '0') {
            localStorage.setItem('permisos', JSON.stringify(perfil.permisos));
          }
          if (perfil.usuario.idUserRefer != '0') {
            this._serv
              .obenerUsuarioPoIdUsuario(perfil.usuario.idUserRefer)
              .subscribe((s: any) => {
                this._serv
                  .findProfileByUser(s.idUserKeycloak)
                  .subscribe((response) => {
                    if (response) {
                      this.mapearPermisos(response);
                    } else {
                      Swal.fire({
                        icon: 'error',
                        title: 'Sin información para usuario ' + id,
                        html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; No se pudo recuperar el perfil del usuario`,
                      });
                    }
                  });
              });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Sin información para usuario ' + id,
            html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; No se pudo recuperar el perfil del usuario`,
          });
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Ocurrió un error',
          html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; No se pudo recuperar el perfil del usuario`,
        });
      }
    );
  }

  mapearPermisos(lista: any) {
    lista.forEach((item: any) => {
      if (item.producto === 'MaestroSocios') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.MaestroSocios.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.MaestroSocios.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.MaestroSocios.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.MaestroSocios.borrar = true;
        }
      }
      if (item.producto === 'MantPrecioCompo') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.MantPrecioCompo.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.MantPrecioCompo.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.MantPrecioCompo.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.MantPrecioCompo.borrar = true;
        }
      }
      if (item.producto === 'PrecioPromSem') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.PrecioPromSem.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.PrecioPromSem.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.PrecioPromSem.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.PrecioPromSem.borrar = true;
        }
      }
      if (item.producto === 'PrecioFijoSem') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.PrecioFijoSem.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.PrecioFijoSem.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.PrecioFijoSem.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.PrecioFijoSem.borrar = true;
        }
      }
      if (item.producto === 'PrecioFijoVig') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.PrecioFijoVig.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.PrecioFijoVig.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.PrecioFijoVig.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.PrecioFijoVig.borrar = true;
        }
      }
      if (item.producto === 'MantAcciones') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.MantAcciones.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.MantAcciones.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.MantAcciones.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.MantAcciones.borrar = true;
        }
      }
      if (item.producto === 'MantContratos') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.MantContratos.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.MantContratos.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.MantContratos.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.MantContratos.borrar = true;
        }
      }
      if (item.producto === 'MantLitrosAcciones') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.MantLitrosAcciones.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.MantLitrosAcciones.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.MantLitrosAcciones.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.MantLitrosAcciones.borrar = true;
        }
      }
      if (item.producto === 'TopesDia') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.TopesDia.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.TopesDia.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.TopesDia.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.TopesDia.borrar = true;
        }
      }
      if (item.producto === 'TopesSemana') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.TopesSemana.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.TopesSemana.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.TopesSemana.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.TopesSemana.borrar = true;
        }
      }
      if (item.producto === 'FormulasCalidad') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.FormulasCalidad.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.FormulasCalidad.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.FormulasCalidad.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.FormulasCalidad.borrar = true;
        }
      }
      if (item.producto === 'Bancos') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Bancos.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Bancos.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Bancos.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Bancos.borrar = true;
        }
      }
      if (item.producto === 'Rutas') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Rutas.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Rutas.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Rutas.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Rutas.borrar = true;
        }
      }
      if (item.producto === 'Sucursales') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Sucursales.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Sucursales.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Sucursales.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Sucursales.borrar = true;
        }
      }
      if (item.producto === 'Tanques') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Tanques.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Tanques.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Tanques.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Tanques.borrar = true;
        }
      }
      if (item.producto === 'Veterinarios') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Veterinarios.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Veterinarios.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Veterinarios.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Veterinarios.borrar = true;
        }
      }
      if (item.producto === 'Plantas') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Plantas.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Plantas.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Plantas.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Plantas.borrar = true;
        }
      }
      if (item.producto === 'TipoDesvios') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.TipoDesvios.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.TipoDesvios.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.TipoDesvios.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.TipoDesvios.borrar = true;
        }
      }
      if (item.producto === 'RelPago') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.RelPago.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.RelPago.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.RelPago.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.RelPago.borrar = true;
        }
      }
      if (item.producto === 'Conceptos') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Conceptos.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Conceptos.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Conceptos.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Conceptos.borrar = true;
        }
      }
      if (item.producto === 'ControlConcepCia') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.ControlConcepCia.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.ControlConcepCia.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.ControlConcepCia.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.ControlConcepCia.borrar = true;
        }
      }
      if (item.producto === 'CompTransportistas') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.CompTransportistas.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.CompTransportistas.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.CompTransportistas.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.CompTransportistas.borrar = true;
        }
      }
      if (item.producto === 'MovRecoleccion') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.MovRecoleccion.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.MovRecoleccion.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.MovRecoleccion.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.MovRecoleccion.borrar = true;
        }
      }
      if (item.producto === 'AgrupRutasMovRecol') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.AgrupRutasMovRecol.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.AgrupRutasMovRecol.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.AgrupRutasMovRecol.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.AgrupRutasMovRecol.borrar = true;
        }
      }
      if (item.producto === 'ConcFactSocios') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.ConcFactSocios.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.ConcFactSocios.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.ConcFactSocios.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.ConcFactSocios.borrar = true;
        }
      }
      if (item.producto === 'GrupAparcerias') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.GrupAparcerias.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.GrupAparcerias.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.GrupAparcerias.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.GrupAparcerias.borrar = true;
        }
      }
      if (item.producto === 'RegionesRecol') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.RegionesRecol.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.RegionesRecol.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.RegionesRecol.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.RegionesRecol.borrar = true;
        }
      }
      if (item.producto === 'GrupArrendamientos') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.GrupArrendamientos.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.GrupArrendamientos.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.GrupArrendamientos.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.GrupArrendamientos.borrar = true;
        }
      }
      if (item.producto === 'ContSirla') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.ContSirla.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.ContSirla.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.ContSirla.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.ContSirla.borrar = true;
        }
      }
      if (item.producto === 'TablaCompensaciónLog') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.TablaCompensacionLog.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.TablaCompensacionLog.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.TablaCompensacionLog.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.TablaCompensacionLog.borrar = true;
        }
      }
      if (item.producto === 'MantClaseA') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.MantClaseA.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.MantClaseA.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.MantClaseA.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.MantClaseA.borrar = true;
        }
      }
      if (item.producto === 'Capturas') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Capturas.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Capturas.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Capturas.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Capturas.borrar = true;
        }
      }
      if (item.producto === 'Reportes') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Reportes.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Reportes.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Reportes.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Reportes.borrar = true;
        }
      }
      if (item.producto === 'AnLecheTanque') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.AnLecheTanque.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.AnLecheTanque.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.AnLecheTanque.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.AnLecheTanque.borrar = true;
        }
      }
      if (item.producto === 'Procesos') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Procesos.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Procesos.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Procesos.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Procesos.borrar = true;
        }
      }
      if (item.producto === 'CargaMilkoScan') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.CargaMilkoScan.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.CargaMilkoScan.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.CargaMilkoScan.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.CargaMilkoScan.borrar = true;
        }
      }
      if (item.producto === 'CargaColLPC') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.CargaColLPC.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.CargaColLPC.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.CargaColLPC.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.CargaColLPC.borrar = true;
        }
      }
      if (item.producto === 'Consultas') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Consultas.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Consultas.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Consultas.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Consultas.borrar = true;
        }
      }
      if (item.producto === 'DirSocios') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.DirSocios.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.DirSocios.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.DirSocios.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.DirSocios.borrar = true;
        }
      }
      if (item.producto === 'Deducciones') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Deducciones.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Deducciones.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Deducciones.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Deducciones.borrar = true;
        }
      }
      if (item.producto === 'Contabilidad') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Contabilidad.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Contabilidad.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Contabilidad.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Contabilidad.borrar = true;
        }
      }
      if (item.producto === 'ProcCrioscopia') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.ProcCrioscopia.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.ProcCrioscopia.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.ProcCrioscopia.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.ProcCrioscopia.borrar = true;
        }
      }
      if (item.producto === 'Accesos') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Accesos.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Accesos.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Accesos.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Accesos.borrar = true;
        }
      }
      if (item.producto === 'Usuarios') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Usuarios.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Usuarios.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Usuarios.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Usuarios.borrar = true;
        }
      }
      if (item.producto === 'Perfiles') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Perfiles.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Perfiles.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Perfiles.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Perfiles.borrar = true;
        }
      }
      if (item.producto === 'JuegoVal') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.JuegoVal.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.JuegoVal.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.JuegoVal.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.JuegoVal.borrar = true;
        }
      }
      if (item.producto === 'Regiones') {
        if (item.funcion === 'Editar') {
          perfilUsarAccesoDe.permisos.Regiones.edicion = true;
        }
        if (item.funcion === 'Consulta') {
          perfilUsarAccesoDe.permisos.Regiones.consulta = true;
        }
        if (item.funcion === 'Reportes') {
          perfilUsarAccesoDe.permisos.Regiones.reportes = true;
        }
        if (item.funcion === 'Borrar') {
          perfilUsarAccesoDe.permisos.Regiones.borrar = true;
        }
      }
    });
    localStorage.setItem(
      'permisos',
      JSON.stringify(perfilUsarAccesoDe.permisos)
    );
  }

  validarEstadoUsuario(userId: string) {
    const urlEstadoUsuario = `${environment.validarEstadoUsuario}${userId}`;

    this._http.post<UserStatusResponse>(urlEstadoUsuario, {}).subscribe(
      (response) => {
        if (response.bloqueado) {
          console.log(response.mensaje);
          Swal.fire('Error', 'El usuario está bloqueado.', 'error').then(() => {
            this.keycloak.logout();
            localStorage.clear();
            this.loadUserData();
          });
        } else {
          console.log('El usuario no está bloqueado.');
        }
      },
      (error) => {
        console.log('Error al validar el estado del usuario');
        Swal.fire(
          'Error',
          'Error al validar el estado del usuario',
          'error'
        ).then(() => {
          this.keycloak.logout();
          localStorage.clear();
          this.loadUserData();
        });
      }
    );
  }
}
